/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

// Import actionType constants
import {
  HISTORY_FETCH_REQUEST,
  HISTORY_FETCH_REQUEST_SUCCESS,
  HISTORY_FETCH_REQUEST_FAILURE,
  CLEAN_HISTORY_PROPS,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const historyReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CLEAN_HISTORY_PROPS:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    case HISTORY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case HISTORY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case HISTORY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    default:
      return state;
  }
};

export default historyReducer;
